import React from 'react'
import DateText from 'orionsoft-parts/lib/components/fields/DateText'
import Text from 'orionsoft-parts/lib/components/fields/Text'
import styles from './styles.css'
import moment from 'moment'
import useState from 'App/hooks/useState'
import isNull from 'lodash/isNull'
// import Button from 'orionsoft-parts/lib/components/Button'
// import DateIcon from 'react-icons/lib/md/date-range'

const timeFormat = 'HH:mm:ss'
const dateFormat = 'DD-MM-YYYY'

export default function DateTime(props) {
  const [hourState, setHourState] = useState(null)
  const hourValue = isNull(hourState)
    ? props.value
      ? moment(props.value).format(timeFormat)
      : ''
    : hourState

  const checkHour = () => {
    const parsed = moment(hourState, timeFormat)
    if (!parsed.isValid()) {
      setHourState(null)
      return
    }

    const finalDate = `${moment(props.value).format(dateFormat)} ${parsed.format(timeFormat)}`
    const date = moment(finalDate, dateFormat + ' ' + timeFormat)

    props.onChange(date.toDate())
    setHourState(null)
  }

  return (
    <div>
      <div className="label">{props.label}</div>
      <div className={styles.inputs}>
        <div className="row">
          <div className="col-xs-12 col-sm-6">
            <DateText
              value={props.value}
              onChange={props.onChange}
              passProps={{placeholder: 'DD-MM-YYYY'}}
            />
          </div>
          <div className="col-xs-12 col-sm-6">
            {props.value ? (
              <Text
                value={hourValue}
                onChange={setHourState}
                passProps={{onBlur: checkHour}}
                onEnter={checkHour}
                placeholder="HH:mm:ss"
              />
            ) : null}
          </div>
          {/* <div className="col-xs-12 col-sm-2">
            <Button
              icon={DateIcon}
              onClick={() =>
                props.onChange(
                  moment()
                    .startOf('week')
                    .add(1, 'week')
                    .add(12, 'hours')
                    .toDate()
                )
              }>
              Lunes
            </Button>
          </div> */}
        </div>
      </div>
      <div className="description">
        {props.value ? moment(props.value).format('LLL Z') + '. ' : ''}
        {props.description}
      </div>
      <div className="os-input-error">{props.errorMessage}</div>
    </div>
  )
}
